import {
  formatUnitAmount,
  getPriceMinUnitAmount
} from "components/FormerEditor/common/currency";
import compact from "lodash/compact";
const getProductName = (product) => product.title || product.name;

export const getProductDeleteModalSlides = (product) => [
  {
    title: `Delete product`,
    header: `Are you sure you want to delete the ${getProductName(
      product
    )} product?`,
    subheader: `If yes, this product will be deleted within your connected Stripe account. All prices related to this product will also be deleted, and you'll have to re-create them if you want to use them within PriceBlocs.`,
    tertiary:
      "Alternatively you can manage this product on Stripe using the link below."
  }
];

export const getProductArchiveModalSlides = (product) => [
  {
    title: `Archive product`,
    header: `Are you sure you want to archive the ${getProductName(
      product
    )} product?`,
    subheader: `If yes, this product and its prices can no longer be used for checkout and will be archived within your connected Stripe account. If you are using this product within any payment link or page, you should replace it with an active product.`,
    tertiary:
      "Products can only be deleted on Stripe. You can manage this product within your Stripe dashboard using the link below."
  }
];

export const getPriceDeleteModalSlides = ({ price, product }) => [
  {
    title: `Delete price`,
    header: `Are you sure you want to delete this ${formatUnitAmount({
      amount: getPriceMinUnitAmount(price),
      currency: price.currency
    })} price for ${getProductName(product)} product?`,
    subheader: compact([
      `If yes, this price will be deleted within your connected Stripe account.`,
      price.recurring
        ? `Any active subscriptions using this price will be unaffected.`
        : ""
    ]),
    tertiary:
      "Alternatively you can manage this price on Stripe using the link below."
  }
];

export const getPriceArchiveModalSlides = ({ price, product }) => [
  {
    title: `Archive price`,
    header: `Are you sure you want to archive this ${formatUnitAmount({
      amount: getPriceMinUnitAmount(price),
      currency: price.currency
    })} price for ${getProductName(product)}?`,
    subheader: compact([
      `If yes, this price can no longer be used for checkout and will be archived within your connected Stripe account. If you are using this price within any payment link or page, you should replace it with an active price.`,
      price.recurring
        ? `Any active subscriptions using this price will remain active until canceled.`
        : ""
    ]),
    tertiary:
      "Prices can only be deleted on Stripe. You can manage this price within your Stripe dashboard using the link below."
  }
];

export const getShortLinkDeleteModalSlides = () => [
  {
    title: `Delete link`,
    subheader: `Are you sure you want to delete this link? If yes, you will lose any related analytics information and the link will be unavailable for use.`,
    tertiary: `Alternatively you can the keep the link but set its status to "Archived" so that it is not available for use, but still exists.`
  }
];

export const getCouponDeleteModalSlides = () => [
  {
    title: `Delete coupon`,
    subheader: `Are you sure you want to delete this coupon? If yes, this coupon and its promotional codes will no longer be available for use. Deleting this coupon will not affect discounts for customers who have already redeemed the coupon, but new redemptions of the coupon won't be allowed.`
  }
];

export const getIntegrationDeleteModalSlides = () => [
  {
    title: `Delete integration`,
    subheader: `Are you sure you want to delete this integration?`
  }
];

export const getTaxRateDeleteModalSlides = () => [
  {
    title: `Delete tax rate`,
    subheader: `Are you sure you want to delete this tax rate?`
  }
];

export const getAttachmentDeleteModalSlides = (attachment) => [
  {
    title: "Delete file",
    subheader: `Are you sure you want to delete this file, ${attachment.data.filename}? If yes, this file will no longer be available for download, including for any completed customer purchases where this file was attached as part of the sale.`
  }
];

export const getCampaignDeleteModalSlides = (campaign) => [
  {
    title: "Delete campaign",
    subheader: `Are you sure you want to delete this campaign?`
  }
];

export const getDatasourceDeleteModalSlides = () => [
  {
    title: "Delete datasource",
    subheader: `Are you sure you want to delete this datasource?`
  }
];

export const getLegalContentDeleteModalSlides = (model) => [
  {
    title: "Delete legal content",
    subheader: `Are you sure you want to delete this legal content, ${model.title}?`
  }
];

export const getWorkflowDeleteModalSlides = () => [
  {
    title: `Delete workflow`,
    subheader: `Are you sure you want to delete this workflow?.`
  }
];
